"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCanvas = exports.resizeCanvas = exports.drawImageToBaseLayer = void 0;
var dom = __importStar(require("./domElements.ts"));
var config = __importStar(require("./config.ts"));
var state = __importStar(require("./state.ts"));
var drawingUtils_ts_1 = require("./drawingUtils.ts");
var animationManager_ts_1 = require("./animationManager.ts");
var mockCursorManager_ts_1 = require("./mockCursorManager.ts");
function drawImageToBaseLayer(image) {
    if (state.baseLayerCanvas && state.baseLayerCtx && image) {
        var canvas = state.baseLayerCanvas;
        var ctx = state.baseLayerCtx;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (state.isMobileLayout) {
            // Mobile: "cover" behavior. Scale to fill, crop excess, maintain aspect ratio.
            var scaleX = canvas.width / image.naturalWidth;
            var scaleY = canvas.height / image.naturalHeight;
            var scale = Math.max(scaleX, scaleY); // Use the larger scale to cover
            var scaledWidth = image.naturalWidth * scale;
            var scaledHeight = image.naturalHeight * scale;
            var dx = (canvas.width - scaledWidth) / 2;
            var dy = (canvas.height - scaledHeight) / 2;
            ctx.drawImage(image, dx, dy, scaledWidth, scaledHeight);
        }
        else {
            // Desktop: Stretch to fit
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
    }
}
exports.drawImageToBaseLayer = drawImageToBaseLayer;
function resizeCanvas() {
    if (!dom.canvas || !dom.ctx || !dom.canvas.parentElement)
        return;
    var currentImageMode = state.imageLayoutMode;
    // Determine grid configuration and isMobileLayout state
    var isMobile = config.updateGridConfigurationForScreenSize();
    state.setIsMobileLayout(isMobile);
    var newRequiredMode = state.isMobileLayout ? "mobile" : "desktop";
    // If an image is loaded, but it's for the wrong layout mode, flag it for reload.
    if (state.loadedImage && currentImageMode !== newRequiredMode) {
        state.setNeedsImageReload(true);
    }
    var parentWidth = dom.canvas.parentElement.clientWidth;
    var flowerWidthInSegments = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS;
    var newSegmentSize = 4; // A default minimum
    if (parentWidth > 0 &&
        flowerWidthInSegments > 0 &&
        config.TARGET_FLOWERS_HORIZONTALLY > 0) {
        newSegmentSize = Math.floor(parentWidth / (config.TARGET_FLOWERS_HORIZONTALLY * flowerWidthInSegments));
        newSegmentSize = Math.max(2, newSegmentSize); // Ensure a minimum size of 2px for visibility
    }
    state.setCalculatedSegmentSize(newSegmentSize);
    var flowerGridCellPixelSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    // Width is determined by TARGET_FLOWERS_HORIZONTALLY
    var numCols = config.TARGET_FLOWERS_HORIZONTALLY;
    var newCanvasWidth = numCols * flowerGridCellPixelSize;
    dom.canvas.width = newCanvasWidth;
    // Height is determined by TARGET_FLOWERS_VERTICALLY
    var numRows = config.TARGET_FLOWERS_VERTICALLY;
    var newCanvasHeight = numRows * flowerGridCellPixelSize;
    dom.canvas.height = newCanvasHeight;
    if (state.baseLayerCanvas && state.baseLayerCtx) {
        state.baseLayerCanvas.width = dom.canvas.width;
        state.baseLayerCanvas.height = dom.canvas.height;
        if (state.loadedImage) {
            drawImageToBaseLayer(state.loadedImage);
        }
        else {
            state.baseLayerCtx.clearRect(0, 0, state.baseLayerCanvas.width, state.baseLayerCanvas.height);
        }
    }
    var newLogicalGrid = {
        offsetX: 0,
        offsetY: 0,
        numCols: numCols,
        numRows: numRows,
        totalWidthPx: newCanvasWidth,
        totalHeightPx: newCanvasHeight
    };
    state.setLogicalGridCells(newLogicalGrid);
    var now = performance.now();
    state.mockUserCursors.forEach(function (user) {
        if (flowerGridCellPixelSize > 0 &&
            state.logicalGridCells.numCols > 0 &&
            state.logicalGridCells.numRows > 0) {
            var initialCellCol = Math.floor(Math.random() * state.logicalGridCells.numCols);
            var initialCellRow = Math.floor(Math.random() * state.logicalGridCells.numRows);
            var initialX = state.logicalGridCells.offsetX +
                initialCellCol * flowerGridCellPixelSize;
            var initialY = state.logicalGridCells.offsetY +
                initialCellRow * flowerGridCellPixelSize;
            user.currentPixelX = initialX;
            user.currentPixelY = initialY;
            user.targetCell = { x: initialX, y: initialY };
            user.previousCell = { x: initialX, y: initialY };
        }
        else {
            user.currentPixelX = -1000;
            user.currentPixelY = -1000;
            user.targetCell = null;
            user.previousCell = null;
        }
        user.movementStartTime = now;
        user.lastDecisionTime = now + Math.random() * 1000;
        user.isMoving = false;
        (0, mockCursorManager_ts_1.prerenderMockCursor)(user, flowerGridCellPixelSize);
    });
    (0, animationManager_ts_1.startAnimation)();
}
exports.resizeCanvas = resizeCanvas;
function renderCanvas() {
    if (!dom.ctx ||
        !dom.canvas ||
        dom.canvas.width === 0 ||
        dom.canvas.height === 0 ||
        !state.logicalGridCells)
        return;
    var now = performance.now();
    dom.ctx.clearRect(0, 0, dom.canvas.width, dom.canvas.height);
    if (state.baseLayerCanvas) {
        dom.ctx.drawImage(state.baseLayerCanvas, 0, 0, dom.canvas.width, dom.canvas.height);
    }
    else if (state.loadedImage) {
        dom.ctx.drawImage(state.loadedImage, 0, 0, dom.canvas.width, dom.canvas.height);
    }
    else {
        dom.ctx.fillStyle = "#282828";
        dom.ctx.fillRect(0, 0, dom.canvas.width, dom.canvas.height);
    }
    state.permanentFlowers.forEach(function (flower) {
        (0, drawingUtils_ts_1.drawPatternedShape)(flower.clickGridX, flower.clickGridY, flower.maxRingIndex, flower.patternSegments, undefined, flower);
    });
    var nowForRender = performance.now();
    state.activeEffects.forEach(function (effect) {
        var elapsedTime = nowForRender - effect.startTime;
        var currentMaxRingToDrawForThisEffect = Math.min(effect.maxRingIndex, Math.floor(elapsedTime / config.ANIMATION_STEP_DURATION));
        (0, drawingUtils_ts_1.drawPatternedShape)(effect.clickGridX, effect.clickGridY, currentMaxRingToDrawForThisEffect, effect.patternSegments, effect, undefined);
    });
    var isSweepCurrentlyActive = state.isSweeping;
    var sweepLineVisualY_screen = -1;
    if (isSweepCurrentlyActive &&
        state.logicalGridCells.totalHeightPx > 0 &&
        dom.canvas.height > 0) {
        var sweepProgress = Math.max(0, Math.min(1, (state.sweepLineY - state.logicalGridCells.offsetY) /
            state.logicalGridCells.totalHeightPx));
        sweepLineVisualY_screen = sweepProgress * dom.canvas.height;
        if (sweepLineVisualY_screen > 0 && state.baseLayerCanvas) {
            dom.ctx.save();
            // Avoid using ctx.clip() because it can cause performance issues in Safari
            dom.ctx.drawImage(state.baseLayerCanvas, 0, 0, dom.canvas.width, sweepLineVisualY_screen, 0, 0, dom.canvas.width, sweepLineVisualY_screen);
            dom.ctx.restore();
        }
    }
    var flowerGridCellPixelSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    var mainCursorHasActiveConnectionThisFrame = false;
    if (state.currentHoveredPrimaryCell &&
        flowerGridCellPixelSize > 0 &&
        config.numberOfMockUsers > 0 &&
        state.mockUserCursors.length > 0) {
        if (now >= state.initialCursorVisibilityDelayEndTime) {
            // Only attempt connections if cursors are visible
            var mainCell = state.currentHoveredPrimaryCell;
            var S_1 = flowerGridCellPixelSize;
            var mainTL_1 = { x: mainCell.x, y: mainCell.y };
            var mainTR_1 = { x: mainCell.x + S_1, y: mainCell.y };
            var mainBL_1 = { x: mainCell.x, y: mainCell.y + S_1 };
            var mainBR_1 = { x: mainCell.x + S_1, y: mainCell.y + S_1 };
            var mainCenterX_1 = mainCell.x + S_1 / 2;
            var mainCenterY_1 = mainCell.y + S_1 / 2;
            state.mockUserCursors.forEach(function (mockCursor) {
                var mockCursorAbsoluteX = mockCursor.currentPixelX;
                var mockCursorAbsoluteY = mockCursor.currentPixelY;
                if (mockCursorAbsoluteX <
                    state.logicalGridCells.offsetX - flowerGridCellPixelSize * 2 ||
                    mockCursor.isMoving)
                    return;
                var mockCellX = mockCursorAbsoluteX;
                var mockCellY = mockCursorAbsoluteY;
                var mockCenterX = mockCellX + S_1 / 2;
                var mockCenterY = mockCellY + S_1 / 2;
                var deltaXCells = mockCenterX - mainCenterX_1;
                var deltaYCells = mockCenterY - mainCenterY_1;
                var distance = Math.sqrt(deltaXCells * deltaXCells + deltaYCells * deltaYCells);
                // Only connect if directly adjacent (horizontally, vertically, or diagonally)
                if (distance < S_1 * 1.5) {
                    mainCursorHasActiveConnectionThisFrame = true;
                    dom.ctx.strokeStyle = config.CONNECTED_CURSOR_HIGHLIGHT_COLOR;
                    dom.ctx.lineWidth = 2;
                    var mockTL = { x: mockCellX, y: mockCellY };
                    var mockTR = { x: mockCellX + S_1, y: mockCellY };
                    var mockBL = { x: mockCellX, y: mockCellY + S_1 };
                    var mockBR = { x: mockCellX + S_1, y: mockCellY + S_1 };
                    var relX = mainCenterX_1 - mockCenterX;
                    var relY = mainCenterY_1 - mockCenterY;
                    // Main cursor is top-right (relX > 0, relY < 0) or bottom-left (relX < 0, relY > 0) -> Anti-diagonal
                    if ((relX > 0 && relY < 0) || (relX < 0 && relY > 0)) {
                        // Connect TL-TL and BR-BR
                        dom.ctx.beginPath();
                        dom.ctx.moveTo(mainTL_1.x, mainTL_1.y);
                        dom.ctx.lineTo(mockTL.x, mockTL.y);
                        dom.ctx.stroke();
                        dom.ctx.beginPath();
                        dom.ctx.moveTo(mainBR_1.x, mainBR_1.y);
                        dom.ctx.lineTo(mockBR.x, mockBR.y);
                        dom.ctx.stroke();
                    }
                    else {
                        // Main cursor is top-left, bottom-right, or axial -> Main-diagonal connection
                        // Connect BL-BL and TR-TR
                        dom.ctx.beginPath();
                        dom.ctx.moveTo(mainBL_1.x, mainBL_1.y);
                        dom.ctx.lineTo(mockBL.x, mockBL.y);
                        dom.ctx.stroke();
                        dom.ctx.beginPath();
                        dom.ctx.moveTo(mainTR_1.x, mainTR_1.y);
                        dom.ctx.lineTo(mockTR.x, mockTR.y);
                        dom.ctx.stroke();
                    }
                }
            });
        }
    }
    if (flowerGridCellPixelSize > 0) {
        dom.ctx.strokeStyle = mainCursorHasActiveConnectionThisFrame
            ? config.CONNECTED_CURSOR_HIGHLIGHT_COLOR
            : config.DEFAULT_GRID_HIGHLIGHT_COLOR;
        dom.ctx.lineWidth = 2;
        var drawnHighlights_1 = new Set();
        var drawHighlight = function (cell, isPrimary) {
            if (isPrimary === void 0) { isPrimary = false; }
            if (cell) {
                var key = "".concat(cell.x, "-").concat(cell.y);
                if (!drawnHighlights_1.has(key)) {
                    if (isPrimary) {
                        dom.ctx.strokeStyle = mainCursorHasActiveConnectionThisFrame
                            ? config.CONNECTED_CURSOR_HIGHLIGHT_COLOR
                            : config.DEFAULT_GRID_HIGHLIGHT_COLOR;
                    }
                    else {
                        dom.ctx.strokeStyle = config.DEFAULT_GRID_HIGHLIGHT_COLOR;
                    }
                    var inset = dom.ctx.lineWidth / 2;
                    dom.ctx.strokeRect(cell.x + inset, cell.y + inset, flowerGridCellPixelSize - inset * 2, flowerGridCellPixelSize - inset * 2);
                    drawnHighlights_1.add(key);
                }
            }
        };
        drawHighlight(state.currentHoveredPrimaryCell, true);
        drawHighlight(state.currentHoveredMirrorXCell);
        drawHighlight(state.currentHoveredMirrorYCell);
        drawHighlight(state.currentHoveredMirroredCell);
    }
    if (config.numberOfMockUsers > 0 &&
        flowerGridCellPixelSize > 0 &&
        state.mockUserCursors.length > 0) {
        if (now >= state.initialCursorVisibilityDelayEndTime) {
            // Check before drawing mock cursors
            state.mockUserCursors.forEach(function (user) {
                var userAbsoluteX = user.currentPixelX;
                var userAbsoluteY = user.currentPixelY;
                if (userAbsoluteX <
                    state.logicalGridCells.offsetX - flowerGridCellPixelSize * 2 ||
                    userAbsoluteX >
                        state.logicalGridCells.offsetX +
                            state.logicalGridCells.totalWidthPx +
                            flowerGridCellPixelSize * 2 ||
                    userAbsoluteY <
                        state.logicalGridCells.offsetY - flowerGridCellPixelSize * 2 ||
                    userAbsoluteY >
                        state.logicalGridCells.offsetY +
                            state.logicalGridCells.totalHeightPx +
                            flowerGridCellPixelSize * 2) {
                    return;
                }
                dom.ctx.strokeStyle = user.color;
                dom.ctx.lineWidth = 2;
                var inset = dom.ctx.lineWidth / 2;
                dom.ctx.strokeRect(userAbsoluteX + inset, userAbsoluteY + inset, flowerGridCellPixelSize - inset * 2, flowerGridCellPixelSize - inset * 2);
                dom.ctx.fillStyle = user.color;
                var ipFontSize = 10;
                dom.ctx.font = "bold ".concat(ipFontSize, "px Arial");
                dom.ctx.textAlign = "left";
                dom.ctx.textBaseline = "top";
                var textX = userAbsoluteX + 4;
                var textY = userAbsoluteY + 4;
                dom.ctx.fillText(user.id, textX, textY);
                if (user.designation) {
                    var designationFontSize = 10;
                    textY += ipFontSize + 2;
                    dom.ctx.font = "bold ".concat(designationFontSize, "px Arial");
                    dom.ctx.fillText(user.designation, textX, textY);
                }
            });
        }
    }
    if (isSweepCurrentlyActive &&
        sweepLineVisualY_screen >= 0 &&
        sweepLineVisualY_screen <= dom.canvas.height) {
        dom.ctx.strokeStyle = config.SWEEP_LINE_COLOR;
        dom.ctx.lineWidth = 2;
        dom.ctx.beginPath();
        dom.ctx.moveTo(0, sweepLineVisualY_screen);
        dom.ctx.lineTo(dom.canvas.width, sweepLineVisualY_screen);
        dom.ctx.stroke();
    }
}
exports.renderCanvas = renderCanvas;
